const Tracks = [
  {
    id: 1,
    title: "CYBERSECURITY",
    description:
      "Focuses on safeguarding systems, networks, and data from digital threats. Key objectives include developing solutions for stronger cybersecurity infrastructure, threat detection, and user awareness. Cybersecurity is critical to protect against financial losses, reputational damage, and regulatory penalties.",
    icon: require('../assets/Cybersecurity.png'),
  },
  {
    id: 2,
    title: "ARTIFICIAL INTELLIGENCE",
    description:
      "Simulates human intelligence processes using computer systems. Key objectives include developing AI solutions for healthcare, finance, transportation, and education. AI enables predictive analytics, personalized recommendations, and automation.",
    icon: require('../assets/ai.png'),
  },
  {
    id: 3,
    title: "BLOCKCHAIN",
    description:
      "Decentralized technology ensuring secure and transparent transactions. Key objectives include exploring blockchain applications in supply chain, healthcare, and digital identity. Blockchain can revolutionize processes by improving data security and transactional transparency.",
    icon: require('../assets/blockchain.png'),
  },
  {
    id: 4,
    title: "ROBOTICS",
    description:
      "Involves designing and operating robots for various applications. Key objectives include developing innovative robotic solutions, addressing ethical concerns, and improving human-robot collaboration. Robotics drives efficiency and innovation in manufacturing, healthcare, and more.",
    icon: require('../assets/robotics.png'),
  },
  {
    id: 5,
    title: "OPEN INNOVATION",
    description:
      "Involves sharing and collaborating on ideas across boundaries. Key objectives include encouraging collaboration, idea sharing, and cultivating a culture of openness and trust. Leveraging external expertise accelerates innovation and problem-solving.",
    icon: require('../assets/open.png'),
  },
  {
    id: 6,
    title: "INTERNET OF THINGS",
    description:
      "Connects devices embedded with sensors and software to collect and exchange data. Key objectives include improving decision-making, resource utilization, and user experiences through IoT applications. IoT drives operational efficiency and data-driven insights across industries.",
    icon: require('../assets/iot.png'),
  },
  {
    id: 7,
    title: "AR/VR",
    description:
      "Technologies offer immersive experiences by overlaying digital content or creating virtual environments. Key objectives include exploring AR/VR applications in gaming, education, healthcare, and more. AR/VR enhances user engagement and productivity.",
    icon: require('../assets/arvr.png'),
  },
  {
    id: 8,
    title: "CRYPTOGRAPHY",
    description:
      "Involves techniques for secure communication and data protection. Key objectives include enhancing data security, privacy, and trust with advanced cryptographic solutions. Cryptography is essential for protecting against cyber threats and ensuring secure transactions.",
    icon: require('../assets/crypto.png'),
  },
  {
    id: 9,
    title: "DEEP FAKE",
    description:
      "Creates realistic but fake images, videos, or audio using AI. Key objectives include exploring implications on society, media, and security, and developing detection and prevention methods. Deep Fakes raise concerns about misinformation and public trust.",
    icon: require('../assets/deepfake.png'),
  },
];

export default Tracks;
